/*
 * Zaun-Skizzen-Generator – gemeinsam genutzt von Zaunplaner und
 * Zaunfeld-Konfigurator. Zeichnet ein Zaunfeld schematisch, aber
 * modellgetreu (nach den echten Produktfotos):
 *
 *   skizze-Konfiguration je Modell (in data/regeln.json):
 *     kopf:           'spitz' | 'schraeg' | 'rund' | 'flach' – Form der Lattenköpfe
 *                     ('schraeg' = Rundlatte schräg abgeschnitten: Körper bleibt
 *                      Rechteck, die Schnittfläche zeigt nach vorn und erscheint
 *                      als helle Halbellipse am Lattenkopf)
 *     spitzeFaktor:   Zahl  – Steilheit der Spitze (Spitzenhöhe = Breite × Faktor,
 *                             Standard 1.8; kleiner = flacher)
 *     profil:         'rund' | 'eckig'             – Halbrund-/Rundlatte vs. Vierkant
 *     riegel:         'rund' | 'flach'             – Halbrundriegel vs. Vierkantriegel
 *     riegelVorne:    true  – Riegel vor den Latten montiert
 *     hoehenversatz:  cm    – jede 2. Latte sitzt tiefer (Hoch-Tief-Optik)
 *     tiefenwechsel:  true  – jede 2. Latte hinter dem Riegel (durchgesteckt)
 *
 * Die Farben richten sich nach dem Material (Fichte KDI vs. Lärche).
 * Kanonische Kopie: existiert identisch in konfigurator/assets und
 * feld_konfigurator/assets – bei Änderungen beide aktualisieren!
 */
(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) { module.exports = factory(); }
  else { root.ZaunSkizze = factory(); }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var PALETTEN = {
    fichte: {
      latte: '#c99a68', latteRand: '#a97843',
      latteHinten: '#b0885c', latteHintenRand: '#8f6a41',
      riegel: '#b98a55', riegelRand: '#96693c',
      schnitt: '#e7d2a6'
    },
    laerche: {
      latte: '#e5c07d', latteRand: '#c09144',
      latteHinten: '#d2ab62', latteHintenRand: '#a8842f',
      riegel: '#dab469', riegelRand: '#b28c3f',
      schnitt: '#f2dfb0'
    }
  };

  function palette(material) {
    return /rche/i.test(material || '') ? PALETTEN.laerche : PALETTEN.fichte;
  }

  function n(x) { return Number(x).toFixed(1); }

  /* Eine Latte von yTop bis yBottom, Kopfform + Profil-Highlight. */
  function latteSvg(x, yTop, breite, yBottom, cfg, fuellung, rand, schnitt) {
    var teile = [];
    var koerperOben = yTop;

    if (cfg.kopf === 'spitz') {
      var spitze = Math.min(12, breite * (cfg.spitzeFaktor || 1.8));
      koerperOben = yTop + spitze;
      teile.push('<path d="M' + n(x) + ',' + n(koerperOben) +
        ' L' + n(x + breite / 2) + ',' + n(yTop) +
        ' L' + n(x + breite) + ',' + n(koerperOben) +
        ' L' + n(x + breite) + ',' + n(yBottom) +
        ' L' + n(x) + ',' + n(yBottom) + ' Z" fill="' + fuellung + '" stroke="' + rand + '" stroke-width="0.6"/>');
    } else if (cfg.kopf === 'schraeg') {
      // Schräg abgeschnittene Rundlatte: Körper als Rechteck, die nach vorn
      // zeigende Schnittfläche als helle Halbellipse unter der Oberkante.
      // Tiefe über schnittFaktor justierbar (Standard 0.5 × Lattenbreite).
      var tiefe = Math.min(5, breite * (cfg.schnittFaktor || 0.5));
      koerperOben = yTop + tiefe;
      teile.push('<rect x="' + n(x) + '" y="' + n(yTop) + '" width="' + n(breite) +
        '" height="' + n(yBottom - yTop) + '" rx="0.8" fill="' + fuellung + '" stroke="' + rand + '" stroke-width="0.6"/>');
      teile.push('<path d="M' + n(x) + ',' + n(yTop) +
        ' A' + n(breite / 2) + ',' + n(tiefe) + ' 0 0 0 ' + n(x + breite) + ',' + n(yTop) +
        ' Z" fill="' + (schnitt || '#e7d2a6') + '" stroke="' + rand + '" stroke-width="0.6"/>');
    } else if (cfg.kopf === 'rund') {
      var r = breite / 2;
      koerperOben = yTop + r;
      teile.push('<path d="M' + n(x) + ',' + n(yBottom) +
        ' L' + n(x) + ',' + n(koerperOben) +
        ' A' + n(r) + ',' + n(r) + ' 0 0 1 ' + n(x + breite) + ',' + n(koerperOben) +
        ' L' + n(x + breite) + ',' + n(yBottom) + ' Z" fill="' + fuellung + '" stroke="' + rand + '" stroke-width="0.6"/>');
    } else {
      teile.push('<rect x="' + n(x) + '" y="' + n(yTop) + '" width="' + n(breite) +
        '" height="' + n(yBottom - yTop) + '" rx="0.8" fill="' + fuellung + '" stroke="' + rand + '" stroke-width="0.6"/>');
    }

    // Rundprofil: schmaler Licht-Streifen deutet die Wölbung an
    if (cfg.profil === 'rund') {
      teile.push('<rect x="' + n(x + breite * 0.26) + '" y="' + n(koerperOben + 1) +
        '" width="' + n(breite * 0.2) + '" height="' + n(Math.max(0, yBottom - koerperOben - 3)) +
        '" rx="' + n(breite * 0.1) + '" fill="#ffffff" opacity="0.22"/>');
    }
    return teile.join('');
  }

  /* Ein Riegel über die volle Feldlänge, halbrund oder eckig. */
  function riegelSvg(x, yMitte, laenge, cfg, pal) {
    if (cfg.riegel === 'rund') {
      var h = 8;
      return '<rect x="' + n(x) + '" y="' + n(yMitte - h / 2) + '" width="' + n(laenge) + '" height="' + h +
        '" rx="' + (h / 2) + '" fill="' + pal.riegel + '" stroke="' + pal.riegelRand + '" stroke-width="0.6"/>' +
        '<rect x="' + n(x + 2) + '" y="' + n(yMitte - h / 2 + 1.5) + '" width="' + n(Math.max(0, laenge - 4)) +
        '" height="2" rx="1" fill="#ffffff" opacity="0.25"/>';
    }
    var hf = 7;
    return '<rect x="' + n(x) + '" y="' + n(yMitte - hf / 2) + '" width="' + n(laenge) + '" height="' + hf +
      '" rx="0.8" fill="' + pal.riegel + '" stroke="' + pal.riegelRand + '" stroke-width="0.6"/>';
  }

  /*
   * Ein komplettes Zaunfeld als SVG-Fragment.
   * opts: { x, y, laengeCm, hoeheCm, latte: {breite_cm, anzahl_pro_m},
   *         skizze: {...}, material: 'Fichte KDI' | 'Lärche', nurLatten?: true }
   * (x, y) = linke obere Ecke des Feldes; Latten enden unten bei y + hoeheCm.
   */
  function feld(opts) {
    var latte = opts.latte || {};
    var cfg = opts.skizze || {};
    var pal = palette(opts.material);
    var x0 = opts.x, y0 = opts.y, L = opts.laengeCm, H = opts.hoeheCm;

    // ceil wie im Berechnungskern, damit Skizze und Stückliste dieselbe Lattenzahl zeigen
    var anzahl = Math.max(2, Math.ceil((Number(latte.anzahl_pro_m) || 9) * L / 100));
    var pitch = L / anzahl;
    var lb = Math.min(Number(latte.breite_cm) || 6, pitch * 0.75);
    var versatz = cfg.hoehenversatz || 0;

    var vorne = [];
    var hinten = [];
    for (var i = 0; i < anzahl; i++) {
      var lx = x0 + i * pitch + (pitch - lb) / 2;
      var istHinten = !!cfg.tiefenwechsel && i % 2 === 1;
      var yTop = y0 + (i % 2 === 1 ? versatz : 0);
      var ziel = istHinten ? hinten : vorne;
      ziel.push(latteSvg(lx, yTop, lb, y0 + H, cfg,
        istHinten ? pal.latteHinten : pal.latte,
        istHinten ? pal.latteHintenRand : pal.latteRand,
        pal.schnitt));
    }

    // Der Türchen-Zeichner setzt die modellabhängigen Latten zwischen einen
    // eigenen Rahmen aus 133 × 36 mm starken Hölzern. Dafür werden hier nur
    // die Latten benötigt; bestehende Zaunfeld-Aufrufer bleiben unverändert.
    if (opts.nurLatten) return hinten.join('') + vorne.join('');

    var riegel = [0.18, 0.66].map(function (f) {
      return riegelSvg(x0, y0 + H * f + 4, L, cfg, pal);
    }).join('');

    if (cfg.riegelVorne) {
      return hinten.join('') + vorne.join('') + riegel;
    }
    return hinten.join('') + riegel + vorne.join('');
  }

  return { feld: feld, palette: palette };
}));
